export const P2PLinkTypes = {
  MODAL_FREIGHT: "MODAL_FREIGHT",
  MODAL_EXPRESS: "MODAL_EXPRESS",
  LINK: "LINK",
};
